import { useParams } from 'react-router-dom';

export const usePubKeyParam = (): string => {
  const { pubKey } = useParams() as { pubKey: string };
  return pubKey;
};
